import React from 'react'

interface IProps {
  sizeStr: string
  [key: string]: any
}

const VideoSize: React.FC<IProps> = ({ sizeStr = '', ...props }) => {
  if (!sizeStr) {
    return null
  }
  let size = ''
  if (-1 !== sizeStr.indexOf('4k')) {
    size = '4k'
  } else if (-1 !== sizeStr.indexOf('2k')) {
    size = '2k'
  }

  if (!size) {
    return null
  }

  return null // 4k，2k 后端接口有问题，下掉

  // return (
  //   <span className={`video-size video-size-${size}`} {...props}>
  //     <style jsx>
  //       {`
  //         .video-size {
  //           display: block;
  //           width: 24px;
  //           height: 18px;
  //           background-size: cover !important;
  //         }
  //         .video-size-4k {
  //           background: url(/static/4k.svg) no-repeat center;
  //         }
  //         .video-size-2k {
  //           background: url(/static/2k.svg) no-repeat center;
  //         }
  //       `}
  //     </style>
  //   </span>
  // )
}

export default VideoSize
